import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { Header } from '../Common';
import Products from '../../Models/Products';
import SimpleReactValidator from 'simple-react-validator';

class BuyerAskEstimation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            info: '',
            title: '',
            description: '',
            category: '',
            subCategory: '',
            date: '',
            budgets: '',
            categories: [],
            subCategories: [],
            budget: [],
            budgetValue: '',
            seller: ''

        };
        SimpleReactValidator.addLocale('klingon', {
            integer: '数字を入れてください.',
            max: ':attribute :max 文字以下にしてください .',
            required: ' :attribute を必須です.',
            min: ':attribute :min 文字以上にしてください .',
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        // this.getCategories();
        this.getBudgetList();
    }

    getBudgetList() {
        Products.getBudget().then(res => {
            this.setState({ budget: res.data.message })
        })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    componentDidMount() {
        window.scrollTo(0, 0)
        var x = JSON.parse(window.localStorage.getItem('info'));
        this.setState({ info: x })
        if (this.props.location.state != null) {
            console.log(this.props.location.state);
            this.setState({ existing: this.props.location.state });
            this.setState({ date: this.props.location.state.application_date });
            this.setState({ title: this.props.location.state.title });
            this.setState({ budgets: this.props.location.state.budget });
            this.setState({ description: this.props.location.state.content });
            this.setState({ seller: this.props.location.state.id });
        }
        console.log(this.props.location.state)
    }

    sendData(e) {
        e.preventDefault()

        if (this.validator.allValid()) {
            this.props.history.push({
                pathname: `/request-confirm/${this.props.match.params.id}`,
                state: {
                    id: this.props.match.params.id,
                    budgets: this.state.budgets,
                    date: this.state.date,
                    title: this.state.title,
                    content: this.state.description,
                    product_id: this.props.match.params.id,
                    buyer_id: this.state.info.id,
                }
            })
        } else {
            this.validator.showMessages();
        }
    }

    updateChange(e) {
        this.setState({
            budgets: e.target.value,
            budgetValue: e.target.key
        })
    }

    button() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <button onClick={this.sendData.bind(this)} type="submit" className="agree_button" style={{ paddingLeft: "1%", paddingRight: "1%", width: "100%" }}>相談内容を確認する</button>
            )
        } else if (isDesktop) {
            return (
                <button onClick={this.sendData.bind(this)} type="submit" className="agree_button" style={{ paddingLeft: "1%", paddingRight: "1%" }}>相談内容を確認する</button>
            )
        }
    }

    handleClick() {
        return (
            <div className="">
                <form >
                    <div className="form-group" style={{ marginTop: '1rem' }}>
                        <label htmlFor="pwd" style={{ marginBottom: '0px' }}><span className="request_fonts mr-4"><b>タイトル</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                        <input style={{ padding: "2%" }} type="text" className="catagory_select" id="title" placeholder="相談したい内容のタイトルを入力してください" value={this.state.title} onChange={this.updateValue.bind(this, 'title')} />
                        <span style={{ color: "red", fontSize: "12px" }}>
                            {this.validator.message('タイトル', this.state.title, 'required')}
                        </span>
                    </div>
                    <div className="form-group">
                        <label htmlFor="pwd" style={{ marginBottom: '0px' }}><span className="request_fonts mr-4"><b>相談内容</b></span><span style={{ color: "red", fontSize: "11px" }}>*必須</span></label>
                        <textarea
                            className="form-control " row="15" id="descrition" placeholder="相談・お願いしたい内容を詳しく入力してください.."
                            value={this.state.description} onChange={this.updateValue.bind(this, 'description')} style={{ height: "175px" }}>
                        </textarea>
                        <span style={{ color: "red", fontSize: "12px" }}>
                            {this.validator.message('相談内容', this.state.description, 'required')}
                        </span>
                    </div>
                    <div>
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <span><b>提案期限</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*必須</span>
                            </div>
                            <div className="col-md-7">
                                <input type="date"
                                    className="catagory_select" id="date" placeholder="Date"
                                    value={this.state.date} onChange={this.updateValue.bind(this, 'date')}
                                    style={{ height: "40px" }}
                                />
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    {this.validator.message('提案期限', this.state.budgets, 'required')}
                                </span>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <span><b>予算目安</b></span>&nbsp;&nbsp;&nbsp;&nbsp;<span style={{ color: "red", fontSize: "11px" }}>*必須</span>
                            </div>
                            <div className="col-md-7">
                                <select
                                    className="catagory_select"
                                    onChange={this.updateChange.bind(this)}
                                    value={this.state.budgets}
                                    style={{ height: "40px" }}
                                >
                                    <option value=''>選択してください</option>
                                    {this.state.budget.map(rp =>
                                        <option value={rp.id} key={rp.budget_range}>
                                            {rp.budget_range}
                                        </option>
                                    )}
                                </select>
                                <span style={{ color: "red", fontSize: "12px" }}>
                                    {this.validator.message('予算目安', this.state.budgets, 'required')}
                                </span>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                        <div className="button_div">
                            <Link to={{
                                pathname: `/request-confirm/${this.props.match.params.id}`,
                                state: {
                                    id: this.props.match.params.id,
                                    budgets: this.state.budgets,
                                    date: this.state.date,
                                    title: this.state.title,
                                    content: this.state.description,
                                    product_id: this.props.match.params.id,
                                    buyer_id: this.state.info.id,
                                }
                            }}>
                                {this.button()}
                                {/* <button onClick={this.sendData.bind(this)} type="submit" className="agree_button" style={{ paddingLeft: "1%", paddingRight: "1%" }}>相談内容を確認する</button> */}
                            </Link>
                        </div>
                    </div>
                </form>
            </div>
        )
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        //For Mobile view 
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="">
                                    <div className="" style={{ textAlign: "left", fontSize: "20px", borderBottom: "1px solid #ccd0c9" }}>
                                        見積り・カスタマイズの相談内容を入力する
                                    </div>
                                    {this.handleClick()}
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-2"></div>
                                <div className="col-md-8">
                                    <div className="">
                                        <div className="ml-5 mr-5" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                            見積り・カスタマイズの相談内容を入力する
                                    </div>
                                        <div className="mini_padding" style={{ paddingTop: '0px' }}>
                                            <div className="mini_padding inner-div" style={{ paddingTop: '0px' }}>

                                                {this.handleClick()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-2"></div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}

export { BuyerAskEstimation }